import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { WorkMonthItem, WorkMonth } from '../models';

export class WorkMonthApi extends ApiModule {
  protected endpoint = '/work-month';

  public async pageWorkMonths(params: any) {
    return this.api.post<PaginatedResponseData<WorkMonthItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadWorkMonthDetails(id: number) {
    return this.api.get<WorkMonth>(`${this.endpoint}?id=${id}`);
  }

  public saveWorkMonth(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteWorkMonth(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getEducationList(educationId: any, workMonthId: any) {
    return this.api.get<WorkMonth[]>(`${this.endpoint}/education-list?educationId=${educationId}&workMonthId=${workMonthId ?? ''}`);
  }
}
